/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ avg: NonNullable<unknown> }} Price_Breakdown_Toggle_One_NightInputs */

const en_price_breakdown_toggle_one_night = /** @type {(inputs: Price_Breakdown_Toggle_One_NightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 night × ${i?.avg} avg`)
};

/**
* | output |
* | --- |
* | "1 night × {avg} avg" |
*
* @param {Price_Breakdown_Toggle_One_NightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_toggle_one_night = /** @type {((inputs: Price_Breakdown_Toggle_One_NightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Toggle_One_NightInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_toggle_one_night(inputs)
});